<template>
  <div class="pt-search">
    <div class="pt-search__inner" v-loading="loading">
      <!-- 搜索结果 -->
      <template v-if="searched">
        <div class="pt-search__summary">
          共找到 <i>{{ total }}</i> 条与 "<i>{{ searchedKeyword }}</i>" 相关的结果
        </div>

        <!-- 列表 -->
        <ul v-if="list.length > 0" class="pt-search__list">
          <li v-for="item in list" :key="item.id" class="pt-search__item" @click="openDetail(item)">
            <span class="pt-search__name" v-html="highlight(item.title || item.name || '')" />
            <span class="pt-search__cat">{{ item.parentNames || item.className || '' }}</span>
            <time class="pt-search__date">{{ formatDate(item.publishTime) }}</time>
          </li>
        </ul>

        <!-- 空 -->
        <div v-else class="pt-search__empty">
          <!-- 未找到相关内容，请尝试其他关键词 -->
           <el-empty description="未找到相关内容，请尝试其他关键词"></el-empty>
        </div>

        <!-- 分页 -->
        <div v-if="totalPages > 1" class="pt-pager">
          <span class="pt-pager__btn" :class="{ 'is-disabled': page <= 1 }" @click="doSearch(page - 1)">上一页</span>
          <span
            v-for="p in visiblePages"
            :key="p"
            class="pt-pager__num"
            :class="{ 'is-active': p === page }"
            @click="doSearch(p)"
          >{{ p }}</span>
          <span class="pt-pager__btn" :class="{ 'is-disabled': page >= totalPages }" @click="doSearch(page + 1)">下一页</span>
        </div>
      </template>

      <!-- 未搜索时的初始状态 -->
      <div v-else class="pt-search__hint">请输入关键词搜索</div>
    </div>
  </div>
</template>

<script>
import { cmsNewsPage } from '@/http/api/CmsApi'
import { navChannels, hiddenChannels } from './portalData'

export default {
  name: 'PortalSearch',
  data () {
    return {
      keyword: '',
      searchedKeyword: '',
      searched: false,
      loading: false,
      list: [],
      total: 0,
      page: 1,
      pageSize: 12,
      totalPages: 1
    }
  },
  computed: {
    visiblePages () {
      var total = this.totalPages
      var cur = this.page
      if (total <= 1) return []
      if (total <= 7) {
        var arr = []
        for (var i = 1; i <= total; i++) { arr.push(i) }
        return arr
      }
      var pages = []
      if (cur <= 4) {
        for (var j = 1; j <= 5; j++) { pages.push(j) }
        pages.push('...')
        pages.push(total)
      } else if (cur >= total - 3) {
        pages.push(1)
        pages.push('...')
        for (var k = total - 4; k <= total; k++) { pages.push(k) }
      } else {
        pages.push(1)
        pages.push('...')
        for (var l = cur - 1; l <= cur + 1; l++) { pages.push(l) }
        pages.push('...')
        pages.push(total)
      }
      return pages
    }
  },
  created () {
    var q = this.$route.query.q || this.$route.query.keyword || ''
    if (q) {
      this.keyword = q
      this.doSearch(1)
    }
  },
  watch: {
    '$route.query.q': {
      handler: function (val) {
        if (val && val !== this.searchedKeyword) {
          this.keyword = val
          this.doSearch(1)
        }
      }
    }
  },
  methods: {
    doSearch: function (p) {
      var kw = this.keyword.trim()
      if (!kw) return
      if (p < 1 || p > this.totalPages) return

      this.page = p
      this.searchedKeyword = kw
      this.searched = true
      this.loading = true
      this.$router.replace({ query: { q: kw } }).catch(function () {})

      var self = this
      cmsNewsPage({
        keyword: kw,
        pageNo: p,
        pageSize: self.pageSize
      }).then(function (res) {
        self.loading = false
        if (res.code === '000' || res.code === '1') {
          var data = res.result
          self.list = data.records || data.list || data.content || []
          self.total = data.total || 0
          self.totalPages = data.pages || data.totalPage || Math.ceil((data.total || 0) / self.pageSize) || 1
        } else {
          self.list = []
          self.total = 0
          self.totalPages = 1
        }
      }).catch(function () {
        self.loading = false
        self.list = []
        self.total = 0
        self.totalPages = 1
      })
    },

    highlight: function (text) {
      if (!this.searchedKeyword || !text) return text
      var kw = this.searchedKeyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      var re = new RegExp('(' + kw + ')', 'gi')
      return String(text).replace(re, '<i class="pt-search__hl" style="color: #FF9230; display: inline;">$1</i>')
    },

    openDetail: function (item) {
      var id = item.id || item.articleId || ''
      if (id) {
        var catName = this.getCategoryName(item)
        this.$router.push({
          path: '/portal/detail/' + id,
          query: {
            channel: this.findChannelKey(catName),
            cat: item.className || item.categoryName || ''
          }
        })
      }
    },

    getCategoryName: function (item) {
      var pn = item.parentNames || ''
      if (pn) {
        var parts = pn.split('/')
        return parts[0] || ''
      }
      return item.className || item.categoryName || ''
    },

    findChannelKey: function (name) {
      if (!name) return ''
      var all = navChannels.concat(hiddenChannels)
      var found = all.find(function (c) { return c.label === name })
      return found ? found.key : ''
    },

    formatDate: function (str) {
      if (!str) return ''
      return String(str).substring(0, 10)
    }
  }
}
</script>

<style lang="less" scoped>
.pt-search {
  position: relative;
  z-index: 1;
  background: var(--pt-bg, #f4f6f9);
}
.pt-search__inner {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 24px 16px 40px;
  min-height: 420px;
}

/* 摘要 */
.pt-search__summary {
  margin-bottom: 16px;
  color: #666;
  font-size: 14px;
  padding: 12px 16px;
  background: #fff;
  border-radius: 6px;
  border: 1px solid var(--pt-line, #eef0f2);
}
.pt-search__summary i {
  display: inline-block;
  color: #c4203b;
  font-style: normal;
}

/* 列表 */
.pt-search__list {
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fff;
  border: 1px solid var(--pt-line, #eef0f2);
  border-radius: 6px;
}
.pt-search__item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border-bottom: 1px solid var(--pt-line-2, #e5e7eb);
  cursor: pointer;
  transition: background 0.2s;
}
.pt-search__item:last-child { border-bottom: 0; }
.pt-search__item:hover { background: #f8fafc; }

.pt-search__name {
  flex: 0 0 60%;
  min-width: 0;
  color: #1a1f2b;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pt-search__item:hover .pt-search__name { color: #0a447c; }

/* 关键字高亮 */
.pt-search__hl {
  color: #FF9230;
  font-style: normal;
}

.pt-search__cat {
  flex: 1 1 auto;
  min-width: 0;
  color: #0a447c;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pt-search__date {
  flex: none;
  margin-left: auto;
  color: var(--pt-muted, #9ca3af);
  font-size: 13px;
  white-space: nowrap;
}

/* 状态 */
.pt-search__empty,
.pt-search__hint {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  color: var(--pt-muted, #9ca3af);
  font-size: 14px;
}

/* 分页 */
.pt-pager {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  padding: 24px 0 6px;
}
.pt-pager__btn,
.pt-pager__num {
  min-width: 32px;
  height: 32px;
  padding: 0 10px;
  line-height: 32px;
  text-align: center;
  border: 1px solid var(--pt-line-2, #e5e7eb);
  border-radius: 4px;
  color: #555;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
}
.pt-pager__num:hover { border-color: #0a447c; color: #0a447c; }
.pt-pager__num.is-active {
  background: #0a447c;
  border-color: #0a447c;
  color: #fff;
}
.pt-pager__btn.is-disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}

/* 响应式 */
@media (min-width: 768px) {
  .pt-search__inner { padding: 30px 24px 48px; }
  .pt-search__item { padding: 18px 20px; }
}
</style>
